import { NavLink, Outlet } from 'react-router-dom'
import { Shield, CreditCard, Droplets, Bell, User } from 'lucide-react'
import { cn } from '../lib/utils'

const nav = [
  { to: '/', label: 'Risk Monitoring', icon: Shield },
  { to: '/expense', label: 'Expense Checkout', icon: CreditCard },
  { to: '/carwash', label: 'Car Wash', icon: Droplets },
]

export function Layout() {
  return (
    <div className="min-h-screen flex flex-col">
      <header className="bg-tms-900 text-white">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="flex h-16 items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="rounded-lg bg-tms-500/20 p-2">
                <Shield className="h-6 w-6 text-tms-100" />
              </div>
              <span className="font-semibold tracking-tight">TMS Pilot</span>
            </div>
            <nav className="flex items-center gap-1">
              {nav.map(({ to, label, icon: Icon }) => (
                <NavLink
                  key={to}
                  to={to}
                  className={({ isActive }) =>
                    cn(
                      'flex items-center gap-2 rounded-md px-3 py-2 text-sm font-medium transition-colors',
                      isActive
                        ? 'bg-white/10 text-white'
                        : 'text-tms-100 hover:bg-white/5 hover:text-white'
                    )
                  }
                >
                  <Icon className="h-4 w-4" />
                  {label}
                </NavLink>
              ))}
            </nav>
            <div className="flex items-center gap-3">
              <button className="relative rounded-full p-2 text-tms-100 hover:bg-white/5">
                <Bell className="h-5 w-5" />
                <span className="absolute right-1.5 top-1.5 h-2 w-2 rounded-full bg-risk-critical ring-2 ring-tms-900" />
              </button>
              <div className="flex h-8 w-8 items-center justify-center rounded-full bg-tms-500/30">
                <User className="h-4 w-4" />
              </div>
            </div>
          </div>
        </div>
      </header>

      <main className="flex-1">
        <Outlet />
      </main>

      <footer className="border-t border-slate-200 bg-white py-4 text-center text-xs text-slate-500">
        TMS Pilot — synthetic demo data only. No production secrets or real customer PII.
      </footer>
    </div>
  )
}
